import React from "react";
import Loader from "src/components/Loader";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";

interface LoadMoreProps extends Translation {
	onClick: () => void;
	loading: boolean;
}

const LoadMore = ({ t, onClick, loading }: LoadMoreProps) => {
	return (
		<button
			onClick={(e) => {
				e.preventDefault();
				if (!loading) {
					onClick();
				}
			}}
			className="w-max flex items-center gap-1 px-2 py-2 rounded-md hover:bg-dark-100 transition-all"
		>
			<div className="flex justify-center items-center w-4 h-4">
				{loading ? (
					<Loader />
				) : (
					<i className="fas text-[14px] fa-angle-double-down"></i>
				)}
			</div>
			<small className="font-bold">{t("label")}</small>
		</button>
	);
};

LoadMore.locale = {
	nl: {
		label: "Laad meer",
	},
	en: {
		label: "Load more",
	},
};

export default withTranslation(LoadMore);
